<template>
  <div class="mortgage-result-broker signed">
    <div class="mortgage-parameters signed">
      <img
        :src="application.bank.logo_square"
        loading="lazy"
        alt=""
        class="bank-logo"
      >
      <!-- suma rozpracovanej ziadosti -->
      <div
        class="bold wrap100px"
        :class="{'red-text-custom' : application.backEndLimitCorrected && application.stage === 'rozpracovana'}"
      >
        {{ getTotalAmountBasedOnCorrection() | dotTheAmount }} EUR
      </div>
      <!-- schvalena pozadovana sadzba ziadosti -->
      <div
        class="bold wrap50px"
      >
        <div :class="{ 'text-crossed': application.sadzba_schvalena !== null }">
          {{ application.sadzba_pozadovana | toFloor(2) }}<span class="upper-index">%</span>
        </div>

        <div v-if="application.sadzba_schvalena !== null">
          {{ application.sadzba_schvalena | toFloor(2) }}<span class="upper-index">%</span>
        </div>
      </div>
      <!-- splatka rozpracovanej ziadosti -->
      <div
        class="bold wrap100px"
      > {{ application.splatka | dotTheAmount }} <span class="upper-index">EUR</span>
      </div>
      <!-- poplatok rozpracovanej ziadosti -->
      <div
        class="bold wrap50px"
      > {{  application.poplatok_za_poskytnutie | dotTheAmount }} <span class="upper-index">EUR</span>
      </div>
      <!-- splatnost rozpracovanej ziadosti -->
      <div class="bold wrap50px">{{ application.splatnost }}
        <span
          class="upper-index">R</span>
      </div>
      <!-- fixacia rozpracovanej ziadosti -->
      <div class="bold wrap50px">{{ application.fix }}</div>
    </div>
    <div class="div-block-144">
      <div class="link-icon-text"
           @click="removeApplication">
      <img class="nav-link-icon filter-primary" src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f1b_icons8-trash.svg" alt="">
        zmazať
      </div>
      <div v-if="application.stage === 'podpisana'" class="link-icon-text">
      <img class="nav-link-icon filter-primary" src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f4a_icons8-clock.svg" alt="">
        na schvaľovaní
      </div>
      <div v-if="application.stage === 'rozpracovana' || application.stage === 'nachystana'"  class="link-icon-text">
        <application-generator-handler :rules="['priority']" :image="image" :application="application"/>
        generovať
      </div>
      <div
        v-if="application.stage === 'rozpracovana' || application.stage === 'nachystana'"
        class="link-icon-text"
        :class="{'signed-action-loading': signingWithoutDocument}"
        @click="handleSignedApplication"
      >
        <img
          class="nav-link-icon filter-primary"
          src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f50_icons8-done.svg"
          alt=""
        >
        {{ signingWithoutDocument ? "ukladám…" : "podpísaná" }}
      </div>
      <!-- <div class="link-icon-text" @click="openHelperPopup">
        <img class="nav-link-icon filter-primary" src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f4d_icons8-ereader.svg" alt="">
        ako podať?
      </div> -->
    </div>
    <div class="uploaded-files-wrapper" v-if="safeFiles.length">
      <div
          class="link-block-7 w-inline-block justify-content-between"
          v-for="(file, index) in safeFiles"
          :key="index"
          v-if="file.type?.code === 'podpisana_ziadost' || file.type?.code === 'vygenerovana_ziadost'"
        >
        <div class="d-flex flex-row mr-3">
          <div class="small">{{ file.name }}</div>
        </div>
        <a
          :href="file.file"
          target="_blank"
          class="text-cta pointer"
          style="text-decoration: none"
        >
          STIAHNUŤ
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import ApplicationMissingInfoHandler
  from "../../../../shared/PopupHandler/Popups/ApplicationMissingInfo/ApplicationMissingInfoHandler";
import ApplicationGeneratorHandler
  from "../../../../shared/PopupHandler/Popups/ApplicationGenerator/ApplicationGeneratorHandler";
import imagesConvert from "../../../../../mixins/imagesConvert";
import {mapGetters} from "vuex";

export default {
  name: "MortgageApplicationSignItem",
  components: {
    ApplicationGeneratorHandler,
    ApplicationMissingInfoHandler
  },
  props: {
    application: Object,
  },
  mixins: [
    imagesConvert,
  ],
  computed: {
    ...mapGetters({
      cloudsGetter: "mortgageDetailCloud/getClouds",
    }),
    applicationCloud() {
      return this.$store.getters["mortgageDetailCloud/getCloudByCloudId"](
        this.application.cloud
      )?.cloudMeta || null;
    },
    safeFiles() {
      return this.applicationCloud?._?.clouds?.[0]?.files || [];
    },
    hasBankApplicationTemplate() {
      const documents = Array.isArray(this.application.application_documents)
        ? this.application.application_documents
        : [];
      return documents.some((document) => (
        document.document_type === "application" && Boolean(document.file)
      )) || Boolean(this.application.ziadost_o_uver);
    }
  },
  async mounted() {
    if (!this.cloudsGetter.find(cloud => cloud.cloudId === this.application.cloud)) {
      await this.$store.dispatch("mortgageDetailCloud/initializeClouds");
    }
  },
  methods: {
    async handleSignedApplication() {
      if (this.signingWithoutDocument) return;
      if (this.hasBankApplicationTemplate) {
        this.openSignedApplicationPopup();
        return;
      }

      this.signingWithoutDocument = true;
      try {
        await this.$store.dispatch("mortgageDetailState/setMortgageApplicationStage", {
          id: this.application.id,
          newStage: "podpisana",
        });
        this.$store.commit("appState/setSuccessMessage", {
          text: "Žiadosť bola označená ako podpísaná.",
          type: "success",
        });
      } catch (error) {
        this.$store.commit("appState/setSuccessMessage", {
          text: "Stav žiadosti sa nepodarilo zmeniť. Skúste to prosím znova.",
          type: "error",
        });
      } finally {
        this.signingWithoutDocument = false;
      }
    },
    openSignedApplicationPopup() {
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        type: null,
        payload: {
          application: this.application,
          applicationCloud: this.applicationCloud,
        },
        component: "SignedApplicationPopUp",
        rules: ["priority"],
      });
    },
    openHelperPopup () {
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        type: null,
        payload: null,
        component: "ApplicationHelpPopUp",
        rules: ['single'],
      })
    },
    removeApplication () {
      const removedApplication = {
        ...this.application,
        stage_old: this.application.stage,
        stage: "zrusena",
      }
      this.$store.dispatch("mortgageDetailState/removeApplication", {removedApplication});
    },
    getTotalAmountBasedOnCorrection() {
      if (this.application.stage === 'rozpracovana') {
        if (this.application.backEndLimitCorrected) {
          return this.application.correctedAmount;
        }
      }
      return (
          this.application.suma_nadobudnutie +
          this.application.suma_refinancovanie +
          this.application.suma_bezucel
        );
    },
  },
  data: () => ({
    image: null,
    signingWithoutDocument: false,
  }),
}
</script>

<style scoped>
.signed-action-loading {
  pointer-events: none;
  opacity: 0.6;
}
</style>
